"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _MyAccountError = _interopRequireDefault(require("../MyAccountError"));
var _PaymentCard = _interopRequireDefault(require("../PaymentCard"));
var _paymentDetailsSlice = require("../../redux/paymentDetailsSlice");
var _popupSlice = require("../../redux/popupSlice");
var _store = require("../../redux/store");
var _PaymentMethodStyled = require("./PaymentMethodStyled");
var _PaymentCardSkeleton = _interopRequireDefault(require("../PaymentCardSkeleton/PaymentCardSkeleton"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var AddIcon = function AddIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      stroke: "#5db98f",
      fill: "#5db98f",
      cx: "19",
      cy: "19",
      r: "18"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "none",
      strokeWidth: "2",
      stroke: "#f0f3fa",
      d: "M19 8.237v21.526M28.763 19H9.237"
    })]
  });
};
AddIcon.defaultProps = {
  width: "38",
  height: "38",
  xmlns: "http://www.w3.org/2000/svg",
  color: "red"
};
const PaymentMethod = () => {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const dispatch = (0, _store.useAppDispatch)();
  const {
    paymentDetails,
    error,
    loading,
    activeOrBoundPaymentDetails
  } = (0, _store.useAppSelector)(_paymentDetailsSlice.selectPaymentDetails);
  const renderPaymentMethodItem = paymentDetail => {
    const {
      paymentMethod,
      id
    } = paymentDetail;
    switch (paymentMethod) {
      case 'card':
      case 'paypal':
      case 'apple':
      case 'android':
      case 'amazon':
      case 'roku':
      case 'googlepay':
      case 'applepay':
      case 'ideal':
      case 'bancontact_card':
      case 'bancontact_mobile':
      case 'sofort':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentCard.default, {
          details: paymentDetail
        }, id);
      default:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentMethodStyled.Message, {
          children: t('paymentmethod.managed-by-external-service', 'Managed by external service')
        });
    }
  };
  const activeItems = activeOrBoundPaymentDetails.find(item => item.active);
  (0, _react.useEffect)(() => {
    if ((paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.length) === 0) {
      dispatch((0, _paymentDetailsSlice.fetchPaymentDetails)());
    }
  }, []);
  if (loading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentMethodStyled.CardsWrapper, {
      numberOfItems: 1,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentCardSkeleton.default, {})
    });
  }
  if (error) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentMethodStyled.WrapStyled, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountError.default, {
        generalError: true
      })
    });
  }
  if (!activeItems) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentMethodStyled.WrapStyled, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentMethodStyled.CardsWrapper, {
        numberOfItems: 1,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountError.default, {
          icon: AddIcon,
          title: t('paymentmethod.no-active-method.title', 'Add a payment method!'),
          subtitle: t('paymentmethod.no-active-method.subtitle', 'Set up a new payment method for your account'),
          withBorder: true,
          onClick: () => {
            dispatch((0, _popupSlice.updatePaymentDetailsPopup)({
              isOpen: true,
              isLoading: false,
              step: _popupSlice.PAYMENT_DETAILS_STEPS.PAYMENT_DETAILS_UPDATE
            }));
          },
          direction: "row",
          fullWidth: true
        })
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentMethodStyled.WrapStyled, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentMethodStyled.CardsWrapper, {
      numberOfItems: activeOrBoundPaymentDetails.length,
      children: activeOrBoundPaymentDetails.map(paymentDetail => renderPaymentMethodItem(paymentDetail))
    })
  });
};
var _default = exports.default = PaymentMethod;